import React, { useState } from 'react';
import { CreditCard, Check } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const UpdatePaymentModal = () => {
  const app = useAppContext();
  const [saved, setSaved] = useState(false);

  const handleSave = async () => {
    setSaved(true);
    await new Promise((r) => setTimeout(r, 1500));
    app.setShowUpdatePaymentModal(false);
    setSaved(false);
  };

  return (
    <Modal
      isOpen={app.showUpdatePaymentModal}
      onClose={() => { app.setShowUpdatePaymentModal(false); setSaved(false); }}
      size="sm"
    >
      <div className="modal__header">
        <div className="modal__icon-wrapper">
          <CreditCard size={28} color="white" />
        </div>
        <h2 className="modal__title">Update Payment</h2>
        <p className="modal__subtitle">
          Enter your new payment details below
        </p>
      </div>
      <div className="modal__body">
        <div className="modal__form">
          <div className="input-group">
            <CreditCard className="input-icon" size={20} />
            <input className="input" type="text" placeholder="Card number" />
          </div>
          <div className="payment-row">
            <div className="input-group">
              <input className="input input--compact" type="text" placeholder="MM/YY" />
            </div>
            <div className="input-group">
              <input className="input input--compact" type="text" placeholder="CVC" />
            </div>
          </div>
          <button className="btn btn-primary btn-full" onClick={handleSave} disabled={saved}>
            {saved ? (
              <>
                <Check size={18} />
                Saved!
              </>
            ) : (
              'Save Payment Method'
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UpdatePaymentModal;
